<script setup lang="ts">
import { mdiChevronUp } from "@mdi/js";

interface Props {
	title: string;
}

defineProps<Props>();
const active = ref(true);
</script>

<template>
	<UiAccordion
		@tab-open="
			() => {
				active = true;
			}
		"
		@tab-close="active = false"
		class="overflow-hidden rounded-lg"
		:activeIndex="0"
	>
		<UiAccordionTab>
			<template #header>
				<div :class="['h-8 bg-dark-700 px-2 text-base font-bold flex items-center', !active && 'rounded-lg']">
					{{ title }}
				</div>
			</template>
			<template #header-icon>
				<div class="absolute -translate-y-1/2 right-2 top-1/2">
					<UiIcon :class="['z-10 w-6 h-6 fill-light-50 transition-all', !active && 'rotate-180']" :path="mdiChevronUp" />
				</div>
			</template>
			<slot />
		</UiAccordionTab>
	</UiAccordion>
</template>
